/** Normalization and filename↔input label similarity for queue folder import. */

export const normalizeForMatch = (s) =>
  (s || "")
    .toString()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

export const cleanFileName = (filename) => {
  let name = filename;
  name = name.replace(/^\d{4}[_-]?\d{2}[_-]/, "");
  return name;
};

export const normalizeString = (s) => {
  let normalized = normalizeForMatch(s);
  normalized = normalized.replace(/[_&-]+/g, " ");
  normalized = normalized.replace(/\s+/g, " ").trim();
  return normalized;
};

export const tokenize = (s) => normalizeString(s).split(" ").filter(Boolean);

export const scoreSimilarity = (fileName, target) => {
  const cleanedFileName = cleanFileName(fileName);
  const a = normalizeString(cleanedFileName);
  const b = normalizeString(target);

  if (!a || !b) return 0;
  if (a === b) return 1.0;

  const fileTokens = new Set(tokenize(cleanedFileName));
  const targetTokens = new Set(tokenize(target));

  if (fileTokens.size === 0 || targetTokens.size === 0) return 0;

  const intersection = new Set(
    [...fileTokens].filter((x) => targetTokens.has(x)),
  );

  if (
    intersection.size === fileTokens.size &&
    intersection.size === targetTokens.size
  ) {
    return 1.0;
  }

  const coverage = intersection.size / targetTokens.size;
  const union = new Set([...fileTokens, ...targetTokens]);
  const jaccard = intersection.size / union.size;

  const sequenceRatio = (() => {
    const longer = a.length > b.length ? a : b;
    const shorter = a.length > b.length ? b : a;
    const longerLen = longer.length;
    if (longerLen === 0) return 1.0;

    let matches = 0;
    const shorterChars = shorter.split("");
    const longerChars = longer.split("");
    const usedIndices = new Set();

    for (const char of shorterChars) {
      for (let i = 0; i < longerChars.length; i++) {
        if (!usedIndices.has(i) && longerChars[i] === char) {
          matches++;
          usedIndices.add(i);
          break;
        }
      }
    }
    return (2 * matches) / (shorter.length + longer.length);
  })();

  return Math.max(
    coverage * 0.7 + jaccard * 0.2 + sequenceRatio * 0.1,
    sequenceRatio,
  );
};
